import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken,removeToken } from '@/utils/token'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register','/teacherRegister']

function getSsoToken(to) {
    if (to && to.query && to.query.sso_token) {
        return to.query.sso_token
    }
    const searchToken = new URLSearchParams(window.location.search || '').get('sso_token')
    if (searchToken) {
        return searchToken
    }
    const hash = window.location.hash || ''
    const queryIndex = hash.indexOf('?')
    if (queryIndex !== -1) {
        return new URLSearchParams(hash.substring(queryIndex + 1)).get('sso_token')
    }
    return ''
}

function buildRedirectPath(to) {
    if (!to) {
        return '/'
    }
    const query = { ...(to.query || {}) }
    delete query.sso_token
    const queryString = new URLSearchParams(query).toString()
    return queryString ? `${to.path}?${queryString}` : to.path
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    if(getToken()) {
        if (whiteList.indexOf(to.path) !== -1) {
            next(`/`)
        }
        // 确保用户信息和权限信息都已加载
        if (!store.getters.getUserInfo) {
          Promise.all([
            store.dispatch('fetchUserInfo'),
            store.dispatch('permission/getPermissions')
          ]).then(() => {
            next()
          }).catch((error) => {
            console.error('加载用户信息或权限失败:', error)
            store.dispatch('clearUserInfo').finally(() => {
              next('/login')
              NProgress.done()
            })
          })
        } else {
          // 如果用户信息已加载，确保权限也被加载
          if (!store.getters['permission/getBtnPermissions'] || store.getters['permission/getBtnPermissions'].length === 0) {
            store.dispatch('permission/getPermissions').catch(error => {
              console.error('加载权限失败:', error)
            })
          }
          next()
        }
    } else {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            // 没有token，检查是否有SSO令牌
            const ssoToken = getSsoToken(to)
            if (ssoToken) {
                // 有SSO令牌，跳转到登录页进行SSO令牌交换
                const query = { sso_token: ssoToken }
                const redirect = buildRedirectPath(to)
                if (redirect && redirect !== '/login') {
                    query.redirect = redirect
                }
                next({ path: '/login', query })
            } else {
                // 无SSO令牌，直接回到本系统登录页
                next({ path: '/login' })
            }
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
